<template>
  <div class="f_content">
    <div class="Employees-Add-New-Employee">
      <router-link to="/employee">Employees ></router-link>
      <a>New Employee</a>
    </div>
    <div class="Onboard-New-Employee">
      <div class="Onboard-New-Employee__name">Onboard New Employee</div>
      <div class="Onboard-New-Employee__btn">
        <router-link to="/multipleEmployee">
          <div>+ Onboard Multiple Employees</div>
        </router-link>
      </div>
    </div>
    <img
      class="img-fluid d-block user"
      src="./../../../assets/style/images/user.svg"
      alt="user added"
    />
    <p class="adduser">Let's Bring The Employee Onboard</p>

    <div>
      <div class="data-fetch-error" v-if="dataFetchError">
        <p>This page did not load successfully. Please try again.</p>
      </div>
    </div>

    <form
      class="needs-validation container employee-entry-form"
      id="newEmployeeform"
    >
      <div>
        <p class="text-primary">Basics</p>
        <div class="form-row">
          <div class="form-div">
            <div class="form-group mr-2">
              <label for="inputFirstname">First Name</label>
              <input
                v-model.trim="newEmployee.firstname"
                type="text"
                class="form-control"
                id="inputFirstname"
                placeholder="First Name"
              />
            </div>
            <div class="form-group">
              <label for="lastname">Last name</label>
              <input
                v-model.trim="newEmployee.lastname"
                type="text"
                class="form-control"
                id="lastname"
                placeholder="last name"
              />
            </div>
          </div>

          <div class="form-div">
            <div class="form-group mr-2">
              <label for="gender">Gender</label>
              <div class="custom-select__input">
                <select v-model.trim="newEmployee.gender" id="gender">
                  <option value selected>Gender</option>
                  <option>Female</option>
                  <option>Male</option>
                </select>
                <div>
                  <font-awesome-icon icon="angle-down" />
                </div>
              </div>
            </div>
            <div class="form-group mr-2">
              <label for="phone">Phone Number</label>
              <input
                v-model.trim="newEmployee.phone"
                type="tel"
                class="form-control"
                id="phone"
                placeholder="+234"
              />
            </div>
            <div class="form-group">
              <label for="email">Email</label>
              <input
                v-model.trim="newEmployee.email"
                type="text"
                class="form-control"
                id="email"
                placeholder="Email Address"
              />
            </div>
          </div>

          <div class="form-div">
            <div class="form-group mr-2">
              <label for="inputAddress">Home Address</label>
              <input
                v-model.trim="newEmployee.address"
                type="text"
                class="form-control"
                id="inputAddress"
                placeholder="Home Address"
              />
            </div>

            <div class="form-group">
              <label for="country">Country</label>

              <div class="company__setting--basic-input" v-show="country">
                <select
                  v-model.trim="newEmployee.country"
                  @change="getState($event)"
                  id="country"
                >
                  <option
                    v-for="countryValue in countryData"
                    :value="countryValue.id"
                    v-bind:key="countryValue.index"
                  >
                    {{ countryValue.name }}
                  </option>
                </select>
                <div>
                  <font-awesome-icon icon="angle-down" />
                </div>
              </div>
              <div
                class="company__setting--basic-input-loader"
                v-show="!country"
              >
                <InputLoader />
              </div>
            </div>
          </div>

          <div class="form-div">
            <div class="form-group mr-2">
              <label for="state">State</label>
              <div>
                <div class="company__setting--basic-input" v-show="state">
                  <select v-model.trim="newEmployee.state" id="state">
                    <option
                      v-for="stateValue in stateData"
                      :value="stateValue.id"
                      v-bind:key="stateValue.index"
                    >
                      {{ stateValue.name }}
                    </option>
                  </select>
                  <div>
                    <font-awesome-icon icon="angle-down" />
                  </div>
                </div>
                <div
                  class="company__setting--basic-input-loader"
                  v-show="!state"
                >
                  <InputLoader />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="city">City</label>
              <div>
                <div class="company__setting--basic-input">
                  <input type="text" v-model.trim="newEmployee.city" />
                </div>
              </div>
            </div>
          </div>

          <div class="form-div">
            <div class="form-group mr-2">
              <label for="jobTitle">Job title</label>
              <div>
                <div class="company__setting--basic-input">
                  <select v-model.trim="designation_id" id="jobTitle">
                    <option value></option>
                    <option
                      v-for="designation in designations"
                      :value="designation.id"
                      v-bind:key="designation.index"
                    >
                      {{ designation.name }}
                    </option>
                  </select>
                  <div>
                    <font-awesome-icon icon="angle-down" />
                  </div>
                </div>
                <div class="form-text">
                  <span v-if="!loading" @click="refreshDesignations"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      class="form-text-spanIcon"
                    >
                      <path
                        d="M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V432c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
                      /></svg
                  ></span>
                  <div class="smallLoader" v-else>
                    <InputLoader />
                  </div>
                  <p class="form-text-link" @click="showCompanySetting">
                    Create a
                    <span class="form-text-span"> job title </span>
                  </p>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="inputStaffID">Staff ID:</label>
              <input
                id="inputStaffID"
                type="text"
                v-model.trim="newEmployee.staff_number"
                class="form-control"
              />
              <div v-if="Loader">
                <InputLoader />
              </div>
              <div class="text-align-end" v-if="!Loader">
                <a
                  class="small"
                  @click.prevent="generateStaffId(newEmployee.email)"
                  href="#"
                  >Generate Staff ID</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section" v-if="componentLoader">
        <p style="text-align: center">
          fetching payroll details...wait a minute
        </p>
      </div>

      <div class="section" v-if="!componentLoader">
        <p class="text-primary">Compensations</p>
        <div>
          <div class="form-row">
            <div
              class="form-div"
              v-for="(comp, index) in compensationComponents"
              :key="index"
            >
              <div class="form-group">
                <label for="reimbursements">{{ comp.name }}</label>
                <div class="icon-input form-control align-items-center">
                  <span>&#8358;</span>
                  <input
                    class="input"
                    type="text"
                    @keyup="formatAmount('compensations', comp.name)"
                    v-model.trim="compensation[comp.name]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section" v-if="!componentLoader">
        <p class="text-primary">Deductibles</p>
        <div>
          <div class="form-div">
            <div
              class="mr-2"
              style="padding-bottom: 20px"
              v-for="(ded, index) in deductibleComponents"
              :key="index"
            >
              <div class="form-group">
                <label for="reimbursements">{{ ded.name }}</label>
                <div class="icon-input form-control align-items-center">
                  <span>&#8358;</span>
                  <input
                    class="input"
                    type="text"
                    pattern="[0-9]*"
                    @keyup="formatAmount('deductibles', ded.name)"
                    v-model.trim="deductible[ded.name]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="error">
          <p v-show="emailError">Please enter a valid email address.</p>
          <p v-if="dataSaveError">{{ dataSaveError }}</p>

          <div v-if="emptyFields">
            <p v-for="(field, index) in emptyFields" :key="index">
              The {{ field }} input is required
            </p>
          </div>
          <p v-if="payrollError">
            An error occurred while trying load payroll details.
          </p>
        </div>
      </div>

      <div>
        <div class="error">
          <div v-if="serverErrors">
            <p v-for="(value, name, index) in serverErrors" :key="index">
              {{ value[0] }}
            </p>
          </div>
        </div>
      </div>

      <div class="text-center endbutton mt-5" v-if="!componentLoader">
        <button
          type="submit"
          v-show="!loading"
          class="btn btn-primary savebutton mr-4"
          @click.prevent="createEmployee()"
        >
          Save & Continue
        </button>
        <div v-show="loading">
          <WhiteLoader />
        </div>

        <button
          type="reset"
          class="btn btn-outline-secondary cancelbutton px-3"
          @click.prevent="cancelForm()"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";
import InputLoader from "../../partials/input-loader";


export default {
  name: "Onboardemployee",
  components: {
    WhiteLoader,
    InputLoader,
  },

  data() {
    return {
      newEmployee: {
        firstname: "",
        lastname: "",
        staff_number: "",
        role: "user",
        email: "",
        phone: "",
        gender: "",
        address: "",
        country: "",
        state: "",
        city: "",
      },

      designations: [],
      designation_id: "",

      compensation: {},
      deductible: {},

      serverErrors: null,

      countryData: "",
      country: false,
      stateData: "",
      state: false,
      cityData: "",
      city: false,

      loading: false,
      Loader: false,

      emptyFields: [],
      numberValidationFields: [],
      emailError: false,
      compensationComponents: [],
      deductibleComponents: [],

      dataFetchError: false,
      dataSaveError: "",
      componentLoader: true,
      payrollError: false,
    };
  },

  computed: {
    companyId() {
      let user = this.$store.getters.currentAuthUser;
      return user.employees.company_id;
    },
  },

  created() {
    this.getCountryOnLoad();
    this.getDesignations();
    this.getPayrollComponents();
  },

  methods: {
    generateStaffId(email) {
      this.Loader = true;

      this.$http
        .post(types.GET_STAFF_ID_API, {
          company_email: email,
        })
        .then((resp) => {
          this.newEmployee.staff_number = resp.data.data.id;
          this.Loader = false;
        })
        .catch((err) => {
          this.Loader = true;
        });
    },
    refreshDesignations() {
      this.loading = true;
      this.$http
        .get(types.GET_DESIGNATION_API)
        .then((resp) => {
          this.loading = false;
          this.designations = resp.data.data;
        })
        .catch((err) => {
          this.loading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },
    formatFun(e) {
      e.target.value = e.target.value.replace(/[^0-9.,]/g, "");
    },

    cancelForm() {
      this.emptyFields = [];
      this.emailError = false;
      this.serverErrors = null;
      this.numberValidationFields = [];
      this.newEmployee = {
        firstname: "",
        lastname: "",
        staff_number: "",
        email: "",
        phone: "",
        gender: "",
        address: "",
        country: "",
        state: "",
        city: "",
      };

      this.compensation = {};
      this.deductible = {};
      this.designation_id = "";
      this.$router.push("/employee");
    },

    showCompanySetting() {
      window.open("/settings?sec=company#company", "_blank");
    },

    getDesignations() {
      this.$http
        .get(types.GET_DESIGNATION_API)
        .then((resp) => {
          this.loading = false;
          this.designations = resp.data.data;
        })
        .catch((err) => {
          this.loading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },

    getPayrollComponents() {
      this.$http
        .get(types.GET_PAYROLL_COMPONENTS_API)
        .then((resp) => {
          for (let index of resp.data.data) {
            if (index.type === "Compensation") {
              this.compensationComponents.push(index);
            }

            if (index.type === "Deductible") {
              this.deductibleComponents.push(index);
            }
          }
          this.componentLoader = false;
        })
        .catch((err) => {
          this.payrollError = true;
          this.componentLoader = true;
        });
    },

    createEmployee() {
      this.serverErrors = null;
      this.dataSaveError = "";

      if (!this.validate()) {
        return;
      }

      this.newEmployee.designation_id = this.designation_id;      

      const compensations = [];
      const deductibles = [];
      for (let index of this.compensationComponents) {
        if (!this.compensation[index.name]) {
          this.compensation[index.name] = "0";
        }
      }
      for (let index of this.deductibleComponents) {
        if (!this.deductible[index.name]) {
          this.deductible[index.name] = "0";
        }
      }
      for (let index of this.compensationComponents) {
        for (let key in this.compensation) {
          if (key === index.name) {
            compensations.push({
              component_id: index.id,
              amount: this.compensation[key]
                ? parseFloat(this.compensation[key].replace(/,/g, ""), 10)
                : 0,
            });
          }
        }
      }
      for (let index of this.deductibleComponents) {
        for (let key in this.deductible) {
          if (key === index.name) {
            deductibles.push({
              component_id: index.id,
              amount: this.deductible[key]
                ? parseFloat(this.deductible[key].replace(/,/g, ""), 10)
                : 0,
            });
          }
        }
      }

      const newEmployee = {
        ...this.newEmployee,
        compensations: [...compensations],
        deductibles: [...deductibles],
      };

      newEmployee.company_id = this.companyId;

      this.loading = true;

      this.$http
        .post(types.GET_EMPLOYEES_API, newEmployee)
        .then((resp) => {
          this.loading = false;
          this.$router.push({
            name: "viewEmployee",
            params: { id: resp.data.data.employees.uuid },
          });
        })
        .catch((err) => {
          this.loading = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    },

    validate() {
      let updateData = this.newEmployee;
      this.emptyFields = [];
      this.emailError = false;
      this.numberValidationFields = [];

      let flag = true;

      for (var key in updateData) {
        if (key !== "designation_id") {
          if (typeof updateData[key] === "string") {
            const value = updateData[key].trim();

            if (!value) {
              flag = false;
              this.emptyFields.push(key);
            }

            const expression = /\S+@\S+\.\S+/;

            if (key === "password" && value.length < 8) {
              this.passwordLengthError = true;
              flag = false;
            }

            if (key == "email" && !expression.test(value)) {
              this.emailError = true;
              flag = false;
            }

            updateData[key] = value;
          }
        }
      }

      return flag;
    },

    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },

    getState() {
      this.state = false;
      this.city = false;

      this.$http
        .get(`${types.STATE_API}/${this.newEmployee.country}`)
        .then((resp) => {
          if (this.isJson(resp.data.data)) {
            this.stateData = JSON.parse(resp.data.data);
          } else {
            this.stateData = resp.data.data;
          }
          this.state = true;
        });
    },

    getCountryOnLoad() {
      this.$http.get(types.COUNTRY_API).then((resp) => {
        if (this.isJson(resp.data.data)) {
          this.countryData = JSON.parse(resp.data.data);
        } else {
          this.countryData = resp.data.data;
        }

        if (this.countryData) {
          this.country = true;

          this.$http
            .get(`${types.STATE_API}/${this.countryData[0].id}`)
            .then((resp) => {
              if (this.isJson(resp.data.data)) {
                this.stateData = JSON.parse(resp.data.data);
              } else {
                this.stateData = resp.data.data;
              }
              this.state = true;
            });
        }
      });
    },

    formatAmount(name, key) {
      if (name === "compensations") {
        let amount = this.compensation[key];

        if (!amount) {
          return;
        }

        if (amount.startsWith("0")) {
          amount = amount.substring(1);
        }

        if (amount.includes(".")) {
          let split = amount.split(".");

          if (split[1].length > 4) {
            this.compensation[key] = amount.substring(0, amount.length - 1);

            return;
          }
        }

        // Remove commas from the amount
        amount = amount.replace(/,/g, "");

        // Check if the amount is a valid number
        this.compensation[key] = this.isValidNumber(amount)
          ? // If it's a valid number, format it using the formatAmountStructure function
            this.formatAmountStructure(amount)
          : // If it's not a valid number, format it manually
            amount
              .substring(0, amount.length - 1)
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }

      if (name === "deductibles") {
        let amount = this.deductible[key];

        if (!amount) {
          return;
        }

        if (amount.startsWith("0")) {
          amount = amount.substring(1);
        }

        if (amount.includes(".")) {
          let split = amount.split(".");

          if (split[1].length > 4) {
            this.deductible[key] = amount.substring(0, amount.length - 1);

            return;
          }
        }

        amount = amount.replace(/,/g, "");

        this.deductible[key] = this.isValidNumber(amount)
          ? this.formatAmountStructure(amount)
          : amount
              .substring(0, amount.length - 1)
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },

    isValidNumber(str) {
      let num = Number(str);
      return !isNaN(num) && str.trim() !== "";
    },

    manualAmountSplit(stringAmount) {
      let split = stringAmount.split(".");
      let nairaPart = split[0];
      let koboPart = split[1];

      return (
        nairaPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + "." + koboPart
      );
    },

    formatAmountStructure(amount) {
      let stringAmount = amount.toString();

      return stringAmount.includes(".")
        ? this.manualAmountSplit(stringAmount)
        : stringAmount.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
  },
};
</script>

<style lang="scss" scoped>
$padding-left-large: 60px;
$padding-right-large: 60px;
$padding-left-medium: 30px;
$padding-right-medium: 30px;
$padding-left-small: 10px;
$padding-right-small: 10px;

.f_content {
  padding-top: 35px;
  padding-left: $padding-left-large;
  padding-right: $padding-right-large;
  padding-bottom: 100px;

  @media (max-width: 768px) {
    padding: 1rem;
  }

  .data-fetch-error {
    width: 835px;
    margin-left: 17px;
    margin-top: 10px;
    text-align: center;
    color: red;
    font-size: 0.938rem;
    font-style: italic;

    p {
      margin: 0;
    }

    p::first-letter {
      text-transform: uppercase;
    }
  }

  input,
  input:focus {
    outline: none;
    box-shadow: none !important;
    border: solid 1px #c7c7c7;
  }

  input {
    border-radius: 7px;
  }

  .form-div {
    display: flex;
    padding: 2rem;
    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .icon-input {
    display: inline-flex;
    border: 1px solid #ccc;
    overflow: hidden;

    span {
      padding-right: 7px;
      width: 20px;
    }

    .input {
      border: 0;
      padding: 0.5rem 0.5rem 0.5rem 0;
      flex: 1;
    }
  }

  .section {
    margin-top: 30px;
  }

  .submit-btn {
    margin-top: 10px;
    margin-bottom: 26px;
  }

  .submit-btn > button {
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #5099de;
    height: 55px;
    border: none;
    outline: none;
    color: #fff;
    font-size: 0.938rem;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }

  .submit-btn > div {
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #5099de;
    height: 55px;
    border: none;
    outline: none;
    color: #fff;
    font-size: 0.938rem;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    padding-top: 15px;
  }

  .company__setting--basic-input {
    // width: 32.083vw;
    border-radius: 7px;
    height: 38px;
    border: solid 1px #c7c7c7;
    background-color: #ffffff;
    overflow: hidden;
    position: relative;

    @media (max-width: 1400px) {
      height: 38px;
    }

    > input {
      height: 38px;
      background-color: #ffffff;
      border: 0;
      outline: 0;
      padding: 0 5px;
      font-size: 1.25rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: #707070;

      @media (max-width: 1400px) {
        height: 38px;
      }
    }

    > select {
      height: 38px;
      background-color: transparent;
      border: 0;
      outline: 0;
      padding: 0 10px;
      font-size: 1.25rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: #707070;
      -moz-appearance: none;
      -webkit-appearance: none;
      position: relative;
      z-index: 2;

      ::-ms-expand {
        display: none;
      }

      @media (max-width: 1400px) {
        height: 38px;
      }
    }

    > div {
      position: absolute;
      top: 0;
      right: 0;
      width: 30px;
      height: 100%;
      text-align: center;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
    }
  }

  .company__setting--basic-input-loader {
    // width: 32.083vw;
    border-radius: 1px;
    height: 38px;
    border: solid 1px #c7c7c7;
    background-color: #ffffff;
    overflow: hidden;

    @media (max-width: 1400px) {
      height: 38px;
    }
  }

  .error {
    margin-top: 10px;
    color: red;
    font-size: 0.938rem;
    font-style: italic;

    p {
      margin-bottom: 0;
      text-align: center;
    }
  }

  .Employees-Add-New-Employee {
    width: 348px;
    height: 50px;
    font-family: Nunito;
    font-size: 1rem;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: #707070;
    text-decoration: none;

    a:first-child {
      color: #5099de;
    }
  }

  .Onboard-New-Employee {
    font-size: 1.198rem;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    display: flex;
    border-bottom: 2px solid #ebe4e4;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    align-content: center;
    padding-bottom: 5px;

    > .Onboard-New-Employee__name {
      width: 20rem;
      font-size: 1.198rem;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
    }

    > .Onboard-New-Employee__btn {
      width: 20rem;
      border-radius: 2px;
      background-color: #5099de;
      color: #fff;
      text-align: center;
      overflow: hidden;

      a {
        color: #fff;
        text-decoration: none;

        > div {
          width: 100%;
          padding: 12px 0;
          font-size: 1rem;
          font-weight: 600;
          font-style: normal;
          font-stretch: normal;
        }
      }
    }
  }

  .onboard {
    width: 300px;
    height: 33px;
    border-radius: 2px;
    background-color: #5099de;
    font-family: Nunito;
    font-size: 0.729rem;
    margin-top: -7px;
  }

  .user {
    width: 100px;
    height: 101.4px;
    height: auto;
    object-fit: contain;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
    margin-bottom: 10px;
  }

  .user + p {
    padding: 0;
    margin: auto;
    text-align: center;
  }

  .adduser {
    // width: 694px;
    height: 50px;
    font-family: Nunito;
    font-size: 1.042rem;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.07;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
    margin-top: 25px;
    padding-right: 12%;
  }

  .employee-entry-form {
    max-width: 50rem;
    margin: auto;
    // height: 1400px;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    padding: 0.5rem 1rem 1rem 3rem;
    // margin: 17px;
    // margin-right: 30px;

    @media (max-width: 768px) {
      padding: 1rem;
    }

    .form-row {
      margin-top: 20px;

      a {
        color: #5099de;
        text-decoration: none;
      }
    }

    ::placeholder {
      color: #777777;
      opacity: 0.5;
    }

    .text-primary {
      color: #5099de !important;
    }

    .group12 {
      width: 12px;
      object-fit: contain;
    }

    .span {
      padding: 35px 0px 0px 2px;
    }

    .benefit12 {
      color: #f49d90;
    }

    .endbutton {
      display: flex;

      @media (max-width: 768px) {
        flex-direction: column;
      }

      .savebutton {
        background-color: #5099de;

        @media (max-width: 768px) {
          margin-bottom: 1rem;
        }
      }

      .cancelbutton {
        color: #6c757d;
      }

      .cancelbutton:hover {
        color: #ffffff;
        background-color: #6c757d;
      }
    }

    .addmore {
      width: 710px;
      border: dotted 1px #5099de;
      font-family: Nunito;
      font-size: 0.781rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 2;
      letter-spacing: normal;
      color: #000000;
      margin-top: 30px;
    }
  }

  .custom-select__input {
    border-radius: 5px;
    height: 38px;
    border: solid 1px #c7c7c7;
    background-color: #ffffff;
    overflow: hidden;
    position: relative;

    > select {
      height: 38px;
      background-color: transparent;
      border: 0;
      outline: 0;
      padding: 0 10px;
      text-align: left;
      -moz-appearance: none;
      -webkit-appearance: none;
      position: relative;
      z-index: 2;
      font-size: 1rem;
      line-height: 1.67;
      color: #777777;

      ::-ms-expand {
        display: none;
      }
    }

    > div {
      position: absolute;
      color: #777777;
      top: 0;
      right: 0;
      width: 30px;
      height: 100%;
      text-align: center;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
    }
  }
}

.form-text {
  font-size: 0.8rem;
  position: relative;
}

.form-text-link {
  cursor: pointer;
  margin-left: 1.3rem;
}

.form-text-span {
  color: #5099de;
  text-decoration: underline;
}

.form-text-spanIcon {
  height: 0.8rem;
  width: 0.8rem;
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 0.2rem;
}

.smallLoader {
  position: absolute;
  top: 0;
  left: 0;
}
</style>